import { orderBy } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  grades: [],
  caseTypes: [],
  report: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.CASE_TYPE_REPORT_GET_CASE_TYPES:
      return {
        ...state,
        caseTypes: {
          ...payload.data,
          Data: orderBy(payload.data.Data, [x => x.Id]),
        },
      };
    case types.CASE_TYPE_REPORT_GET_GRADES:
      return {
        ...state,
        grades: {
          ...payload.data,
          Data: orderBy(payload.data.Data, [x => x.Id]),
        },
      };
    case types.CASE_TYPE_REPORT_GET_REPORT:
      return { ...state, report: payload };

    case types.CASE_TYPE_REPORT_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.CASE_TYPE_REPORT_FETCHING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/casetype/state/casetypereport/reducer.js